import { jsx as _jsx } from "react/jsx-runtime";
import "./shimmer-loader.scss";
export const ShimmerLoader = ({ width = "240px", height = "28px", borderRadius = "4px", containerStyle, }) => {
    const style = {
        width,
        height,
        borderRadius,
    };
    return (_jsx("div", { className: "shimmer-loader", style: Object.assign(Object.assign({}, style), containerStyle) }));
};
